<template>
    <Modal :show="true" :prevent-stop-move="true" :on-close="props.close">
        <div class="verify-modal">
            <div class="verify-modal-title">入場 QR Code</div>
            <img :src="verifyUrl" alt="簽到碼" class="verify-modal-img" />
        </div>
    </Modal>
</template>
<script >
import { use as fegoUse } from '@fegobull/webapi';
import Modal from '../Modal/index.vue';
import { defineProps } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = ['close', 'verifyUrl'];
__sfc_main.setup = (__props, __ctx) => {
  fegoUse.useTeleport(document.body);
  const props = __props;
  return {
    props
  };
};
__sfc_main.components = Object.assign({
  Modal
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.verify-modal {
    width: 5.8rem;
    padding: 0.7rem 0 1.3rem;
    text-align: center;
    background: #fff;
    border-radius: 0.2rem;
    &-title {
        color: #000;
        text-align: center;
        font-family: 'BR Hendrix';
        font-size: 0.42rem;
        font-style: normal;
        font-weight: 600;
        line-height: 100%;
    }

    &-img {
        width: 3.6rem;
        height: 3.6rem;
        margin: 0.6rem auto 0;
    }
}
</style>
